function ETrackerPluginResourceError(etracker) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.assign(config, etracker.getConfig('plugin_resourceerror') || {});
  var ignoreList = config.ignoreList || [];
  var sendResourceError = function sendResourceError(data) {
    etracker.log('resource_error', {
      p1: data.src.substring(0, 10000),
      p2: data.type,
      p3: data.status
    });
  };
  window.addEventListener('error', function (e) {
    if (!(e instanceof ErrorEvent)) {
      var _target$tagName;
      var target = e.target;
      var src = target.src || target.href;
      if (ignoreList.some(function (rule) {
        if (typeof rule === 'string') {
          return rule === src;
        } else if (typeof rule === 'function') {
          try {
            return rule(src, e);
          } catch (e) {}
        } else if (rule instanceof RegExp) {
          return rule.test(src);
        }
      })) {
        return;
      }
      sendResourceError({
        src: src,
        type: (_target$tagName = target.tagName) === null || _target$tagName === void 0 ? void 0 : _target$tagName.toLowerCase()
      });
    }
  }, true);
  return {
    sendResourceError: sendResourceError
  };
}

export { ETrackerPluginResourceError as default };
